import { render, staticRenderFns } from "./vs-toast.vue?vue&type=template&id=ef15ec0e"
import script from "./vs-toast.vue?vue&type=script&lang=js"
export * from "./vs-toast.vue?vue&type=script&lang=js"
import style0 from "./vs-toast.vue?vue&type=style&index=0&id=ef15ec0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports